module.exports = __webpack_public_path__ + "static/img/home1.29ca53e8.png";